import { Fragment, useState, useEffect } from "react";
import { useRouter } from "next/router";

import type { Report } from "content-ui/intelligence/types";

import ProLoginModal from "components/proLoginModal/proLoginModal";
import ClientShowcase from "content-ui/intelligence/components/clientShowcase";
import Reports from "content-ui/intelligence/components/reports";
import { ArrowRightDark } from "components/icons/icons";
import FeaturedReport from "content-ui/intelligence/components/featuredReport";
import { ReportsPageData } from "./fetcher";

type ReportsPageViewProps = {
  dato: ReportsPageData;
  featuredReport: Report;
  reportsList: Report[];
  featuredReportSubtitle: string;
};

const ReportsPageView = ({
  dato,
  featuredReport,
  reportsList,
  featuredReportSubtitle,
}: ReportsPageViewProps) => {
  let [checked, setCheck] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const router = useRouter();

  useEffect(() => {
    const reportRedirect = localStorage.getItem("report_redirect");

    if (reportRedirect) {
      const allReports = [featuredReport, ...reportsList];
      const targetReport = allReports.find(
        (report) => report.title === reportRedirect
      );

      if (targetReport) {
        localStorage.removeItem("report_redirect");

        router.push(`/intelligence/reports/${targetReport.slug}`);
      } else {
        localStorage.removeItem("report_redirect");
      }
    }
  }, [featuredReport, reportsList, router]);

  // TODO: Refactor this component
  return (
    <Fragment>
      <main data-page-type="intelligence-reports">
        <div className="wrapper relative">
          <div className="pb-16 pt-8 md:mx-auto md:w-5/6 md:pb-32 md:pt-32 lg:pt-40">
            <FeaturedReport
              featuredReport={featuredReport}
              featuredReportSubtitle={featuredReportSubtitle}
              checked={checked}
              setCheck={setCheck}
              openModal={setIsModalOpen}
            />
            <div className="mt-4xl flex flex-col items-center md:mt-5xl md:pt-3xl">
              <p className="text-center font-bold text-lg leading-tight md:text-2xl">
                Discover the full range of Intelligence reports
              </p>
              <div className="mt-sm rotate-90 md:mt-md">
                <ArrowRightDark />
              </div>
            </div>

            <div className="mt-3xl text-center md:mt-sm md:pt-3xl md:text-left lg:mt-5xl">
              <h2 className="font-bold text-xl leading-none text-cerise md:text-3xl md:leading-tight">
                Explore our in-depth reports
              </h2>
              <p className="mt-md font-bold text-sm leading-snug text-gray-600 md:text-base">
                Sifted’s in-depth reports investigate the most transformative
                trends shaping startup Europe, across essential sectors, themes
                and geographies. Login to your Sifted account to download them
                for free.
              </p>
            </div>

            <Reports
              className="mt-3xl md:mt-5xl"
              reports={reportsList}
              paywall={dato.paywall}
            />

            <ClientShowcase className="pt-sm md:pt-xl" />
            {dato.paywall && (
              <ProLoginModal
                isOpen={isModalOpen}
                setIsOpen={setIsModalOpen}
                variant="reports"
                paywall={dato.paywall}
              />
            )}
          </div>
        </div>
      </main>
    </Fragment>
  );
};

export default ReportsPageView;
